import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";

// ponytail: ElevenLabs temporarily swapped for LeadConnector chat widget.
// To restore, git-revert this file — the ElevenLabs version is in history.
const SCRIPT_SRC = "https://widgets.leadconnectorhq.com/loader.js";
const RESOURCES_URL = "https://widgets.leadconnectorhq.com/chat-widget/loader.js";
const WIDGET_ID = "6a60cb2cc6e06ac8e8419b70";

export function ElevenLabsWidget() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isDashboard = pathname.startsWith("/dashboard");

  useEffect(() => {
    if (isDashboard) return;
    if (document.querySelector("script[data-leadconnector-widget]")) return;
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.setAttribute("data-resources-url", RESOURCES_URL);
    s.setAttribute("data-widget-id", WIDGET_ID);
    s.setAttribute("data-source", "WEB_USER");
    s.setAttribute("data-leadconnector-widget", "true");
    document.body.appendChild(s);
  }, [isDashboard]);

  return null;
}
